const en = {
  staffTitle: "Staff assignments",
  staffHelp: "Coaches, medics, and team managers with no active club assignment.",
  assign: "Assign",
  club: "Club",
  team: "Team",
  none: "None yet",
  clearancesTitle: "Medical clearances",
  clearancesHelp: "Upload the doctor's letter. The file stays private and opens with a short-lived link.",
  clearanceCardTitle: "Doctor's letter",
  clearanceInjuryLabel: "Injury",
  clearanceSelectInjury: "Select an injury",
  clearanceEmptyTitle: "No injuries to clear yet",
  clearanceEmptyBody: "When a coach or medic records an injury, you can upload the doctor's letter here.",
  upload: "Upload letter",
  openLink: "Open signed link",
  analyticsTitle: "Injury analytics",
  analyticsHelp: "Counts only. Names and dates of birth are not shown.",
  ageBand: "Age band",
  injuryType: "Type",
  count: "Injuries",
  avgDays: "Average days to return",
  retiredTitle: "This injury log has been retired",
  retiredHelp: "New injuries are recorded in Player Welfare. Older rows that could be matched to a team were copied across.",
  openWelfare: "Open player welfare",
  liveTitle: "Live match",
  share: "Share",
  lineupTitle: "Lineup and attendance",
  logisticsTitle: "Match logistics",
  recordingTitle: "Match recording",
  save: "Save",
  publish: "Publish lineup",
  going: "Going",
  maybe: "Maybe",
  no: "No",
  unavailable: "Unavailable",
  limited: "Full training only",
  available: "Available",
  hubTitle: "Tournament",
  fixtures: "Fixtures",
  divisions: "Divisions",
  roster: "Roster",
  checkin: "Check-in",
  schedule: "Schedule",
  waivers: "Waivers",
  officials: "Officials",
  capacity: "Capacity",
  waitlist: "Waitlist",
  confirmed: "Confirmed",
  lockRoster: "Lock roster",
  eligible: "Eligible",
  ineligible: "Not eligible",
  proof: "Proof of age",
  deadline: "Roster deadline",
  acceptWaiver: "Accept waiver and code of conduct",
  scan: "Check in",
  documentsOk: "Documents verified",
  kickoff: "Kickoff",
  pitch: "Pitch",
  assignReferee: "Assign referee",
  profileTitle: "Referee profile",
  grade: "FAM grade",
  region: "Region",
  blackout: "Blackout dates",
  openGames: "Open games",
  claim: "Claim game",
  accept: "Accept",
  decline: "Decline",
  discipline: "Discipline",
  yellows: "Yellows",
  reds: "Reds",
  bans: "Matches to sit",
  official: "Submit official result",
  incidents: "Incidents",
  symptoms: "Symptoms returned",
  dropBack: "Drop back one stage",
  headingWarn: "Heading is not allowed for this age group.",
  createTeams: "Create teams from programmes",
  teamsCreated: "Teams created",
  event: "Event",
  minute: "Minute",
  opsTitle: "Tournament desk",
  deskTitle: "Match desk",
  callTime: "Call time",
  kit: "Kit colour",
  transport: "Transport",
  notes: "Notes",
  home: "Home",
  away: "Away",
  goal: "Goal",
  yellow: "Yellow card",
  red: "Red card",
  substitution: "Substitution",
  penalty: "Penalty",
  ownGoal: "Own goal",
  reason: "Reason",
  documents: "Documents checked",
  downloadWaivers: "Download waiver acceptances",
  postOpen: "Post as an open game",
  attendance: "Match-day attendance",
  player: "Player",
  dob: "Date of birth",
  start: "Kickoff",
  code: "Check-in code",
  name: "Name",
  ageGroup: "Age group",
  playerId: "Player user id",
  symptomsHelp: "At least 8 characters. The player drops back one stage.",
};

const ms: typeof en = {
  staffTitle: "Tugasan kakitangan",
  staffHelp: "Jurulatih, pegawai perubatan, dan pengurus pasukan yang belum ditugaskan ke kelab.",
  assign: "Tugaskan",
  club: "Kelab",
  team: "Pasukan",
  none: "Belum ada",
  clearancesTitle: "Pelepasan perubatan",
  clearancesHelp: "Muat naik surat doktor. Fail kekal peribadi dan dibuka dengan pautan sementara.",
  clearanceCardTitle: "Surat doktor",
  clearanceInjuryLabel: "Kecederaan",
  clearanceSelectInjury: "Pilih kecederaan",
  clearanceEmptyTitle: "Tiada kecederaan untuk dilepaskan lagi",
  clearanceEmptyBody: "Apabila jurulatih atau pegawai perubatan merekod kecederaan, anda boleh muat naik surat doktor di sini.",
  upload: "Muat naik surat",
  openLink: "Buka pautan yang ditandatangani",
  analyticsTitle: "Analisis kecederaan",
  analyticsHelp: "Kiraan sahaja. Nama dan tarikh lahir tidak dipaparkan.",
  ageBand: "Kumpulan umur",
  injuryType: "Jenis",
  count: "Kecederaan",
  avgDays: "Purata hari untuk kembali",
  retiredTitle: "Log kecederaan ini telah ditamatkan",
  retiredHelp: "Kecederaan baharu direkod dalam Kebajikan Pemain. Rekod lama yang dapat dipadankan dengan pasukan telah disalin.",
  openWelfare: "Buka kebajikan pemain",
  liveTitle: "Perlawanan langsung",
  share: "Kongsi",
  lineupTitle: "Barisan dan kehadiran",
  logisticsTitle: "Logistik perlawanan",
  recordingTitle: "Rakaman perlawanan",
  save: "Simpan",
  publish: "Terbitkan barisan",
  going: "Hadir",
  maybe: "Mungkin",
  no: "Tidak",
  unavailable: "Tidak tersedia",
  limited: "Latihan penuh sahaja",
  available: "Tersedia",
  hubTitle: "Kejohanan",
  fixtures: "Jadual",
  divisions: "Divisyen",
  roster: "Senarai pemain",
  checkin: "Daftar masuk",
  schedule: "Jadual masa",
  waivers: "Penepian",
  officials: "Pengadil",
  capacity: "Kapasiti",
  waitlist: "Senarai menunggu",
  confirmed: "Disahkan",
  lockRoster: "Kunci senarai",
  eligible: "Layak",
  ineligible: "Tidak layak",
  proof: "Bukti umur",
  deadline: "Tarikh akhir senarai",
  acceptWaiver: "Terima penepian dan kod tatakelakuan",
  scan: "Daftar masuk",
  documentsOk: "Dokumen disahkan",
  kickoff: "Masa mula",
  pitch: "Padang",
  assignReferee: "Tugaskan pengadil",
  profileTitle: "Profil pengadil",
  grade: "Gred FAM",
  region: "Wilayah",
  blackout: "Tarikh tidak tersedia",
  openGames: "Perlawanan terbuka",
  claim: "Ambil perlawanan",
  accept: "Terima",
  decline: "Tolak",
  discipline: "Disiplin",
  yellows: "Kuning",
  reds: "Merah",
  bans: "Perlawanan digantung",
  official: "Hantar keputusan rasmi",
  incidents: "Insiden",
  symptoms: "Gejala kembali",
  dropBack: "Turun satu peringkat",
  headingWarn: "Tandukan tidak dibenarkan untuk kumpulan umur ini.",
  createTeams: "Cipta pasukan daripada program",
  teamsCreated: "Pasukan dicipta",
  event: "Peristiwa",
  minute: "Minit",
  opsTitle: "Meja kejohanan",
  deskTitle: "Meja perlawanan",
  callTime: "Masa berkumpul",
  kit: "Warna jersi",
  transport: "Pengangkutan",
  notes: "Nota",
  home: "Tuan rumah",
  away: "Pelawat",
  goal: "Gol",
  yellow: "Kad kuning",
  red: "Kad merah",
  substitution: "Pertukaran",
  penalty: "Penalti",
  ownGoal: "Gol sendiri",
  reason: "Sebab",
  documents: "Dokumen disemak",
  downloadWaivers: "Muat turun penerimaan penepian",
  postOpen: "Siarkan sebagai perlawanan terbuka",
  attendance: "Kehadiran hari perlawanan",
  player: "Pemain",
  dob: "Tarikh lahir",
  start: "Masa mula",
  code: "Kod daftar masuk",
  name: "Nama",
  ageGroup: "Kumpulan umur",
  playerId: "ID pengguna pemain",
  symptomsHelp: "Sekurang-kurangnya 8 aksara. Pemain turun satu peringkat.",
};

export const batchBCopy = { en, ms };
